import styled from 'styled-components';
import { NavLink as NavLinkComponent } from 'react-router-dom';
import { ApButtonIcon } from '@alixpartners/ui-components';

import { pageToolbarHeight } from 'styles/spacings';
import { grey400, black, brandColors, hoverGreen } from 'styles/colors';
import { PageToolbarControls as OriginalPageToolbarControls } from 'components/PageToolbar';

const linkSpacing = 8;

export const RightAlignBox = styled.div`
	display: flex;
	flex-wrap: wrap;
	margin-left: auto;
	justify-content: flex-end;
	align-items: center;
`;

export const NavLink = styled(NavLinkComponent)`
	z-index: 1;
	display: flex;
	align-items: center;
	padding: 0 ${linkSpacing}px;
	margin: 0 4px;
	font-size: 13px;
	font-weight: 500;
	text-transform: uppercase;
	color: ${black};
	transition: color 100ms ease-out;
	height: ${pageToolbarHeight};
	border-bottom: 2px solid transparent;
	white-space: nowrap;
	& svg {
		fill: ${grey400};
	}
	@media (hover: hover) {
		&:hover {
			color: ${hoverGreen};
		}
	}

	&.active {
		border-color: ${brandColors.green};
		color: ${brandColors.green};
	}

	&.active svg {
		fill: ${brandColors.green};
	}

	&:hover {
		svg {
			fill: ${hoverGreen};
		}
	}
`;

export const PageToolbarControls = styled(OriginalPageToolbarControls)`
	min-width: 417px;
	${({ fullWidth }) =>
		fullWidth &&
		`
			width: 100%;
			justify-content: initial;
		`};
`;

export const BackButtonWrapper = styled.div`
	min-width: 500px;
	display: flex;
	margin-left: -10px;
`;

export const TransactionsTitle = styled.div`
	font-weight: normal;
	font-size: 19px;
	display: flex;
	align-items: center;
`;

export const ButtonIcon = styled(ApButtonIcon)`
	&& {
		margin: 0 8px 0 0;
	}
`;
